
export default function SkiTrikkeRentals() {
  return (
    <section id="ski-trikke" className="w-full py-16 md:py-24 lg:py-32 px-6 md:px-12 lg:px-24" style={{ backgroundColor: '#F8F7F5' }}>
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-20">
          <h2
            className="text-4xl md:text-5xl lg:text-7xl font-thin tracking-wider text-gray-900 mb-4 md:mb-6"
            style={{ letterSpacing: '2px' }}
          >
            SKKI TRIKKE RENTALS
          </h2>
          <p className="text-lg md:text-xl font-light text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Experience the mountains like never before with our premium Skki Trikke. Innovation meets alpine adventure.
          </p>
        </div>

        {/* Single Rental Card */}
        <div className="flex flex-col lg:flex-row items-center gap-0 bg-white rounded-2xl overflow-hidden shadow-xl max-w-5xl mx-auto">
          {/* Image */}
          <div className="w-full lg:w-1/2 h-64 md:h-80 lg:h-[420px] overflow-hidden flex-shrink-0 bg-gray-100">
            <img
              src="https://skki-trikke.eu/wp-content/uploads/2021/08/TS25_op1_1.jpg"
              alt="Skki Trikke 2026 Green/Grey"
              className="w-full h-full object-contain"
            />
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2 p-6 md:p-10 lg:p-12">
            <span
              className="inline-block text-xs font-semibold tracking-widest uppercase mb-4 px-4 py-2 rounded-full"
              style={{ backgroundColor: '#F0EDE8', color: '#D4AF37' }}
            >
              Available Now
            </span>
            <h3
              className="text-3xl md:text-4xl font-medium text-gray-900 mb-4"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              Skki Trikke 2026 — Green/Grey
            </h3>
            <p className="text-base font-light text-gray-600 mb-6 leading-relaxed">
              The ultimate alpine carving experience. Three skis and a handlebar frame give you full control on the slopes — no ski bindings, no knee pressure, just pure mountain fun. Suitable for all levels, no prior ski experience required.
            </p>

            <ul className="space-y-3 mb-8">
              {[
                'No ski bindings — use your regular winter boots',
                'Quick to learn — in control within 15 minutes',
                'Zero knee pressure — safe and comfortable',
              ].map((feature, idx) => (
                <li key={idx} className="flex items-start gap-3 text-sm font-light text-gray-700">
                  <span className="mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-base" style={{ color: '#D4AF37' }}></i>
                  </span>
                  {feature}
                </li>
              ))}
            </ul>

            <a
              href="#contact"
              className="inline-block px-10 py-4 rounded-full text-sm font-medium tracking-widest uppercase text-white transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#1A2332' }}
            >
              Enquire About Rental
            </a>
          </div>
        </div>

        {/* Delivery Note */}
        <div className="mt-10 flex items-center justify-center gap-4 text-center px-4">
          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
            <i className="ri-e-bike-2-line text-2xl" style={{ color: '#D4AF37' }}></i>
          </div>
          <p className="text-base font-light text-gray-600">
            Rentals of <span className="font-medium text-gray-900">3 days or more</span> include complimentary delivery directly to your chalet.
          </p>
        </div>
      </div>
    </section>
  );
}
